import { AuthZeroProvider } from './providers/AuthZeroProvider';
import { CasProvider } from './providers/CasProvider';
import { DummyProvider } from './providers/DummyProvider';

export class AuthProviderFactory {
    constructor() { }

    build(authConfig, useAuth0) {
        if(authConfig) {
            if (useAuth0) {
                return (authConfig.auth ? new AuthZeroProvider(authConfig.auth) : new AuthZeroProvider(authConfig.authConfig));
            } else {
                return new CasProvider(authConfig.cas);
            }
        }
        else {
            return new DummyProvider();
        }
    }
}

const authFactory = new AuthProviderFactory();
export default authFactory;